import h1 from "../assets/pictures/about/p4.jpeg";
import s2 from "../assets/pictures/home/grid2.jpeg";
import Call from "../components/Call";
import DesktopWa from "../components/DesktopWa";
import { cls } from "../components/Utility";

export default function Rituals() {
  return (
    <>
      <img src={h1} className=" w-full xl:h-[600px] h-[500px] object-cover" />
      <p className="font-[description1] text-[14px] pl-[20px] pr-[20px] xl:pl-[380px] xl:pr-[380px] mt-[40px] mb-[40px] text-center">
        Weddings are more than celebrations — they are sacred sequences of
        culture, memory, and meaning. Every ritual, whether whispered quietly in
        a corner or performed under the grandeur of lights and flowers, tells a
        story passed down through generations. With reverence and detail, we
        capture these traditions not just as events, but as timeless legacies.
        <br />
        <br />
        From the gentle tying of a mangalsutra to the vibrant beats of a haldi
        ceremony, each ritual carries emotion, purpose, and history. Our team
        understands the rhythm of these moments — we don’t just photograph the
        surface, we immerse ourselves in the energy, the symbolism, and the
        sacred silences between words. Every frame becomes a doorway into the
        soul of a culture.
        <br />
        <br />
        Our Rituals Collection is a tribute to the diversity of love across
        traditions — South Indian, North Indian, Christian, Muslim,
        intercultural and beyond. We craft visuals that are rooted in
        authenticity, yet glow with a modern elegance. It's not just about
        documenting rituals — it's about honoring them.
        <br />
        <br />
        Because in the end, rituals are not just customs. They are emotional
        anchors, stitched into the heart of every couple’s story. And we’re here
        to preserve them with beauty, grace, and soul.
      </p>

      <div
        className={cls(
          "flex flex-col pl-[20px] pr-[20px] gap-[10px]",
          "xl:flex xl:flex-row xl:justify-center xl:items-center xl:gap-[10px]"
        )}
      >
        <img
          src={s2}
          className="w-full h-[500px] xl:w-[600px] xl:h-[700px] object-cover"
        />
        <img
          src={s2}
          className="w-full h-[500px] xl:w-[600px] xl:h-[700px] object-cover"
        />
      </div>
      <div
        className={cls(
          "flex flex-col pl-[20px] pr-[20px] gap-[10px] mt-[10px]",
          "xl:flex xl:flex-row xl:justify-center xl:items-center xl:gap-[10px]"
        )}
      >
        <img
          src={s2}
          className="w-full h-[500px] xl:w-[600px] xl:h-[700px] object-cover"
        />
        <img
          src={s2}
          className="w-full h-[500px] xl:w-[600px] xl:h-[700px] object-cover"
        />
      </div>
      <div
        className={cls(
          "flex flex-col pl-[20px] pr-[20px] gap-[10px] mt-[10px] mb-[40px]",
          "xl:flex xl:flex-row xl:justify-center xl:items-center xl:gap-[10px]"
        )}
      >
        <img
          src={s2}
          className="w-full h-[500px] xl:w-[600px] xl:h-[700px] object-cover"
        />
        <img
          src={s2}
          className="w-full h-[500px] xl:w-[600px] xl:h-[700px] object-cover"
        />
      </div>
      <div className="chat-icon">
        <DesktopWa />
      </div>
      <div className="chat-icon1">
        <Call phoneNumber="9980685056" />
      </div>
    </>
  );
}
